module.exports = __webpack_public_path__ + "static/6e446dcda16042c981899b8aab96b78df419cc621e0ed4948717d6527a5913fe-680c242b0058b59c26621d121cf7d4b3.png";